import React from 'react';
import { AppBar, Hidden, Toolbar } from '@material-ui/core';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import NavbarMobileToggleButton from 'app/fuse-layouts/shared-components/NavbarMobileToggleButton';
import UserMenu from 'app/fuse-layouts/shared-components/UserMenu';
import TrialCountdownChip from 'app/fuse-layouts/shared-components/TrialCountdownChip';
import HelpMenu from 'app/fuse-layouts/shared-components/HelpMenu';
import { useSelector } from 'react-redux';
import { useLocation, Link } from 'react-router-dom';
import { FuseAnimate } from '@fuse';
import { Icon, Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
	separator: {
		width: 1,
		height: 64,
		backgroundColor: theme.palette.divider
	},
	appBar: {
		// Translucency lives in the background color, NOT element opacity —
		// opacity composites every child (help dropdown, icons) transparent too
		backgroundColor: 'rgba(43, 50, 69, 0.8)',
		color: '#f8fafc',
		borderBottom: '1px solid #334155'
	}
}));

const ToolbarLayout = props => {
	const socket = props.socket;
	const toolbarTheme = useSelector(({ fuse }) => fuse.settings.toolbarTheme);
	const role = useSelector(({ auth }) => auth.user.role);
	const themeMode = useSelector(({ modernDashboard }) => modernDashboard?.userPreferences?.themeMode || 'dark');
	const classes = useStyles(props);

	//get path url from validate icon
	const location = useLocation();
	
	// Apply dark theme when user preference is dark mode
	const isDarkMode = themeMode === 'dark';
	
	let showBack = false;
	let back = '/clusters';
	if (location.pathname === '/account' || location.pathname === '/settings') {
		showBack = true;
	}

	if (location.pathname === '/account/' + location.pathname.split('/', 3)[2]) {
		showBack = true;
		back = '/account';
	}

	if (location.pathname === '/account-job/' + location.pathname.split('/', 3)[2]) {
		showBack = true;
		back = '/account';
	}
	if (location.pathname === '/account-cluster/' + location.pathname.split('/', 3)[2]) {
		showBack = true;
		back = '/account';
	}

	return (
		<ThemeProvider theme={toolbarTheme}>
			{role.length !== 0 && (
				<AppBar 
					id="fuse-toolbar" 
					className={`flex relative z-10 ${isDarkMode ? classes.appBar : ''}`} 
					color="transparent"
				>
					<Toolbar className="p-0">
						<div className="flex flex-1">
							<Hidden lgUp>
								<NavbarMobileToggleButton className="w-64 h-64 p-0" />
								<div className={classes.separator} />
							</Hidden>
							{showBack && (
								<FuseAnimate animation="transition.slideRightIn" delay={300}>
									<Typography
										id="back-btn"
										className="normal-case flex items-center"
										role="button"
										color="inherit"
										component={Link}
										to={back}
									>
										<Icon className="mr-4 ml-12 text-20">arrow_back</Icon>
										Back
									</Typography>
								</FuseAnimate>
						)}
					</div>
					<div className="flex items-center">
						<HelpMenu />
						<TrialCountdownChip />
						<UserMenu socket={socket} />
					</div>
				</Toolbar>
			</AppBar>
		)}
	</ThemeProvider>
);
};

export default ToolbarLayout;